<div class="row">
  <div class="col-md-12 popin-container align-items justify-content-center">
    <div class="title text-center">
      <h1>Nous vous souhaitons une bonne visite ! :)</h1>
    </div>
  </div>
</div>
